import { render, staticRenderFns } from "./CourseMultUpload.vue?vue&type=template&id=db4da2ba&scoped=true&"
import script from "./CourseMultUpload.vue?vue&type=script&lang=js&"
export * from "./CourseMultUpload.vue?vue&type=script&lang=js&"
import style0 from "./CourseMultUpload.vue?vue&type=style&index=0&id=db4da2ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4da2ba",
  null
  
)

export default component.exports